import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import {
  startDate as defaultStartDate,
  endDate as defaultEndDate,
  year,
} from "../constants";
import { useUserData } from "./UserDataContext";

interface DateContextValue {
  startDate: Date;
  endDate: Date;
  setDates: (startDate: Date, endDate: Date) => void;
}

const DateContext = createContext<DateContextValue | undefined>(undefined);

interface DateProviderProps {
  children: ReactNode;
}

export function DateProvider({ children }: DateProviderProps) {
  const { userData } = useUserData();
  const [startDate, setStartDate] = useState<Date>(defaultStartDate);
  const [endDate, setEndDate] = useState<Date>(defaultEndDate);

  const setDates = (start: Date, end: Date) => {
    setStartDate(start);
    setEndDate(end);
  };

  // Update endDate based on user data
  useEffect(() => {
    if (userData?.newYears2025 === true) {
      setEndDate(new Date(`January 1, ${year + 1}`));
    } else {
      setEndDate(defaultEndDate);
    }
  }, [userData]);

  return (
    <DateContext.Provider value={{ startDate, endDate, setDates }}>
      {children}
    </DateContext.Provider>
  );
}

export function useDates() {
  const context = useContext(DateContext);
  if (context === undefined) {
    throw new Error("useDates must be used within a DateProvider");
  }
  return context;
}
